var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-box"},_vm._l((_vm.groupList),function(item,index){return _c('span',{key:index,class:_vm.currGroup == index?'active':'',on:{"click":function($event){return _vm.changeGroup(item,index)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }